import { ICON__circle_alert } from '@/assets/icons_lucide';

export function G_VIEW__generation_contains_errors() {
  return (
    <div className="flex-center flex-1 h-full">
      <ICON__circle_alert className="size-5 text-danger" />
    </div>
  );
}
